<div class="p-6 space-y-6 bg-light">
  <div class="flex flex-col space-y-4">
    <section
      *ngIf="isLoading"
      class="bg-white overflow-hidden rounded-t-lg animate-pulse"
    >
      <div class="relative w-full h-20 mb-4 bg-gray-300"></div>
      <div class="mt-14 px-6 space-y-2">
        <div class="w-1/2 h-5 bg-gray-300 rounded"></div>
        <div class="w-1/3 h-4 bg-gray-200 rounded"></div>
      </div>
      <div
        class="flex justify-between items-center flex-wrap gap-4 px-6 pb-4 mt-4"
      >
        <div class="flex gap-4 text-sm">
          <div class="w-24 h-4 bg-gray-200 rounded"></div>
          <div class="w-2 h-4 bg-gray-200 rounded"></div>
          <div class="w-24 h-4 bg-gray-200 rounded"></div>
        </div>
        <div class="flex gap-2">
          <div class="w-20 h-8 bg-gray-300 rounded"></div>
          <div class="w-20 h-8 bg-gray-400 rounded"></div>
        </div>
      </div>
    </section>
    <section *ngIf="!isLoading" class="bg-white overflow-hidden rounded-t-lg">
      <div class="relative w-full h-20 sm:h-28 mb-4">
        <img
          [src]="companyBanner()"
          alt="Banner"
          class="w-full h-full object-cover"
        />
        <div class="absolute inset-0 opacity-50 bg-black"></div>
        <div
          class="absolute -bottom-8 left-1/2 sm:left-10 transform -translate-x-1/2 sm:translate-x-0 flex justify-center items-center"
        >
          <img
            [src]="companyImage()"
            alt="Logo"
            class="w-16 h-16 sm:w-20 sm:h-20 object-cover shadow-lg rounded"
          />
        </div>
      </div>
      <div class="mt-14 sm:mt-16 px-4 sm:px-6 text-center sm:text-left">
        <h1 class="text-xl sm:text-2xl font-bold">
          {{ jobDetail?.title }}
        </h1>
        <p class="text-gray-500 text-sm sm:text-base">
          {{ jobDetail?.company?.commercialName }}
        </p>
      </div>
      <div
        class="flex flex-col sm:flex-row justify-between items-center sm:items-start flex-wrap gap-3 sm:gap-4 px-4 sm:px-6 pb-6"
      >
        <div
          class="flex flex-wrap justify-center sm:justify-start gap-2 sm:gap-4 text-sm text-gray-600 items-center"
        >
          <p class="flex items-center gap-1">
            <i class="fa-solid fa-location-dot"></i>
            {{ jobDetail?.company?.district }}
          </p>
          <p class="hidden sm:block">|</p>
          <p class="flex items-center gap-1">
            <i class="fa-regular fa-clock"></i>
            {{ jobDetail?.publicationDate | timeAgo }}
          </p>
          <div
            class="flex items-center rounded-full text-green-800 bg-green-100 px-3 py-1 font-medium relative group cursor-pointer"
          >
            <ng-icon name="heroCheckBadge" size="18"></ng-icon>
            <p class="text-xs sm:text-sm ml-1">Verificada</p>
            <span
              class="absolute bottom-full mb-2 left-1/2 -translate-x-1/2 px-3 py-1 rounded text-xs text-white bg-gray-800 opacity-0 group-hover:opacity-100 transition whitespace-nowrap"
            >
              Compañía verificada por Codideep
            </span>
          </div>
          @if (jobDetail?.publicationStatus === 'Finalizado') {
          <span
            class="bg-red-100 text-red-600 text-xs font-semibold px-3 py-1 rounded-full shadow-sm"
          >
            Oferta finalizada
          </span>
          }
        </div>
        <div
          class="flex justify-center sm:justify-end w-full sm:w-auto mt-2 sm:mt-0"
        >
          <ng-container
            *ngIf="
              jobDetail?.publicationStatus === 'Publicado';
              else closedOffer
            "
          >
            <button
              [disabled]="isLoadingPostulant || postulantExists"
              (click)="openModalPostulate()"
              [ngClass]="{
                'bg-primary text-white': !postulantExists,
                'bg-gray-300 text-gray-600': postulantExists
              }"
              class="px-5 py-2 rounded cursor-pointer flex items-center justify-center min-w-[120px] text-sm sm:text-base transition hover:opacity-90"
            >
              {{ postulantExists ? "Solicitado" : "Solicitar" }}
            </button>
          </ng-container>
          <ng-template #closedOffer>
            <p class="italic text-gray-500 text-sm text-center">
              Ya no se aceptan más postulaciones
            </p>
          </ng-template>
        </div>
      </div>
    </section>
  </div>
  <section class="grid grid-cols-1 md:grid-cols-[7fr_3fr] gap-10 bg-white p-6">
    <section class="space-y-4" *ngIf="!isLoading; else skeletonLeft">
      <div [innerHTML]="jobDetail?.description" class="custom-editor"></div>
    </section>
    <ng-template #skeletonLeft>
      <div class="space-y-4 animate-pulse">
        <div class="h-6 bg-gray-200 rounded w-1/2"></div>
        <div class="h-4 bg-gray-200 rounded w-full"></div>
        <div class="h-4 bg-gray-200 rounded w-3/4"></div>
        <div class="h-6 bg-gray-200 rounded w-1/3 mt-4"></div>
        <div
          *ngFor="let i of [1, 2, 3]"
          class="h-4 bg-gray-200 rounded w-full my-1"
        ></div>
        <div class="h-6 bg-gray-200 rounded w-1/3 mt-4"></div>
        <div class="flex flex-wrap gap-2">
          <div
            *ngFor="let i of [1, 2, 3, 4]"
            class="h-6 w-20 bg-gray-200 rounded-full"
          ></div>
        </div>
      </div>
    </ng-template>
    <div
      class="space-y-4 border-gray-100 border-l px-6"
      *ngIf="!isLoading; else skeletonRight"
    >
      @if(jobDetail?.showSalary == "1"){
      <h2 class="text-xl font-semibold">
        Pago: {{ jobDetail?.salary || "0" | solesCurrency }}
      </h2>
      }
      <div class="space-y-5 text-sm">
        <div class="flex items-center gap-3">
          <div
            class="bg-gray-100 flex items-center justify-center p-2 rounded-md"
          >
            <ng-icon name="ionMailOutline" size="20" color="gray"></ng-icon>
          </div>
          <div>
            <p class="text-sm text-gray-600">Email</p>
            <span>{{ jobDetail?.company?.email }}</span>
          </div>
        </div>
        <div class="flex items-center gap-3">
          <div
            class="bg-gray-100 flex items-center justify-center p-2 rounded-md"
          >
            <ng-icon name="ionBusinessOutline" size="20" color="gray"></ng-icon>
          </div>
          <div>
            <p class="text-sm text-gray-600">Línea de negocio</p>
            <span>{{ jobDetail?.company?.businessLine }}</span>
          </div>
        </div>
        <div class="flex items-center gap-3">
          <div
            class="bg-gray-100 flex items-center justify-center p-2 rounded-md"
          >
            <ng-icon name="ionTimerOutline" size="20" color="gray"></ng-icon>
          </div>
          <div>
            <p class="text-sm text-gray-600">Tipo</p>
            <span>{{ jobDetail?.type }}</span>
          </div>
        </div>
        <div class="flex items-center gap-3">
          <div
            class="bg-gray-100 flex items-center justify-center p-2 rounded-md"
          >
            <ng-icon name="ionReaderOutline" size="20" color="gray"></ng-icon>
          </div>
          <div>
            <p class="text-sm text-gray-600">Área</p>
            <span>{{ jobDetail?.area?.name }}</span>
          </div>
        </div>
        <div class="flex items-center gap-3">
          <div
            class="bg-gray-100 flex items-center justify-center p-2 rounded-md"
          >
            <ng-icon name="ionLibraryOutline" size="20" color="gray"></ng-icon>
          </div>
          <div>
            <p class="text-sm text-gray-600">Nivel de educación</p>
            <span>{{ jobDetail?.education?.name }}</span>
          </div>
        </div>
        <div class="flex items-center gap-3">
          <div
            class="bg-gray-100 flex items-center justify-center p-2 rounded-md"
          >
            <ng-icon name="ionPersonOutline" size="20" color="gray"></ng-icon>
          </div>
          <div>
            <p class="text-sm text-gray-600">Reclutador</p>
            <span>{{ jobDetail?.recluter?.name }}</span>
          </div>
        </div>
      </div>
      <hr class="border-gray-100" />
    </div>
    <ng-template #skeletonRight>
      <div class="space-y-4 border-gray-100 border-l px-6 animate-pulse">
        <div class="h-6 bg-gray-200 rounded w-1/2 mb-4"></div>
        <div
          *ngFor="let i of [1, 2, 3, 4]"
          class="flex items-center gap-3 mb-4"
        >
          <div class="w-10 h-10 bg-gray-200 rounded-md"></div>
          <div class="flex-1">
            <div class="h-4 bg-gray-200 rounded w-3/4 mb-1"></div>
            <div class="h-3 bg-gray-100 rounded w-1/2"></div>
          </div>
        </div>
        <hr class="border-gray-200" />
      </div>
    </ng-template>
  </section>
  <section
    class="mt-6 grid grid-cols-1 md:grid-cols-[7fr_3fr] gap-10 bg-white p-6"
  >
    <div class="space-y-4">
      <ng-container *ngIf="!isLoading; else loadingCompany">
        <h2 class="text-xl font-semibold">Sobre la empresa</h2>
        <div class="flex justify-between items-start gap-4">
          <p class="text-sm text-gray-700 max-w-[70%]">
            {{ jobDetail?.company?.socialReason }}
          </p>
          <div class="text-center space-y-2">
            <img
              [src]="companyImage()"
              class="w-16 h-16 mx-auto rounded-md object-cover shadow-lg"
            />
            <p class="text-xs font-medium text-gray-700 truncate w-32">
              {{ jobDetail?.company?.commercialName }}
            </p>
          </div>
        </div>
        <div class="text-sm text-gray-600 space-y-1">
          <p><strong>Ubicación:</strong> {{ jobDetail?.company?.district }}</p>
          <p><strong>Ruc:</strong> {{ jobDetail?.company?.ruc }}</p>
          <p><strong>Sector:</strong> {{ jobDetail?.company?.businessLine }}</p>
        </div>
      </ng-container>
      <ng-template #loadingCompany>
        <div class="animate-pulse space-y-4">
          <div class="h-4 bg-gray-200 rounded w-2/3"></div>
          <div class="flex gap-4">
            <div class="h-16 w-16 bg-gray-200 rounded-md"></div>
            <div class="flex-1 space-y-2">
              <div class="h-4 bg-gray-200 rounded w-1/2"></div>
              <div class="h-4 bg-gray-200 rounded w-3/4"></div>
              <div class="h-4 bg-gray-200 rounded w-1/4"></div>
            </div>
          </div>
        </div>
      </ng-template>
    </div>
    <!--
    <div class="space-y-4 border-l border-gray-50 px-3">
      <ng-container *ngIf="!isLoading; else loadingOtherJobs">
        <h2 class="text-xl font-semibold">Otros trabajos publicados</h2>
        <div *ngIf="(jobOffers.length ?? 0) > 0; else noJobs">
          <div *ngFor="let item of jobOffers | slice:0:3" class="p-3 rounded space-y-1">
            <p (click)="goToJob(item.idJobOffer)" class="font-medium text-sm cursor-pointer hover:underline transition">
              {{ item.title }}
            </p>
            <div class="flex items-center text-xs text-gray-600 gap-2">
              <img [src]="companyImage()" class="w-5 h-5 object-cover shadow" />
              <span>{{ item.company.commercialName }}</span>
              <span class="text-gray-400">|</span>
              <span>{{ item.publicationDate | date }}</span>
            </div>
          </div>
        </div>
      </ng-container>
      <ng-template #noJobs>
        <p class="text-sm text-gray-500">No hay publicaciones anteriores.</p>
      </ng-template>
      <ng-template #loadingOtherJobs>
        <div class="animate-pulse space-y-4">
          <div class="h-4 bg-gray-200 rounded w-1/3"></div>
          <div class="space-y-2">
            <div class="h-4 bg-gray-200 rounded w-full"></div>
            <div class="h-4 bg-gray-200 rounded w-5/6"></div>
            <div class="h-4 bg-gray-200 rounded w-3/4"></div>
          </div>
        </div>
      </ng-template>
    </div> 
   -->
  </section>
</div>
<div
  *ngIf="modalPostulant"
  class="fixed inset-0 bg-black/70 bg-opacity-60 flex items-center justify-center z-50"
>
  <div class="bg-white rounded-lg shadow-lg max-w-sm w-full p-6 text-center">
    <h2 class="text-lg font-semibold text-gray-800 mb-4">
      ¿Estás seguro que deseas postular a este empleo?
    </h2>
    <div class="flex justify-center gap-4">
      <button
        (click)="closeModalPostulate()"
        class="px-4 py-2 rounded-md border border-gray-300 text-gray-700 hover:bg-gray-100 transition"
      >
        Cancelar
      </button>
      <app-loading-button
        (click)="postulate()"
        [text]="'Confirmar'"
        [loading]="isLoadingPostulant"
        type="button"
      >
      </app-loading-button>
    </div>
  </div>
</div>
